import React from 'react';
import { useWizard } from './WizardContext';

export default function FormField({ name, label, type = 'text', options, ...props }) {
  const { values, setField } = useWizard();
  return (
    <div style={{ margin: '8px 0' }}>
      <label>{label}</label>
      {options ? (
        <select value={values[name] || ''} onChange={e => setField(name, e.target.value)}>
          <option value="">Select</option>
          {options.map(opt => <option key={opt} value={opt}>{opt}</option>)}
        </select>
      ) : (
        <input type={type} value={values[name] || ''} onChange={e => setField(name, e.target.value)} {...props} />
      )}
    </div>
  );
}
